import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import '../css/projects-video.css';

function ProjectsVideo(props) {
  const renderVideo = () => {
    return (
      <React.Fragment>
        <Col className='video-col' xs='12' lg='7'>
          <iframe
            title={props.videoTitle}
            src={props.url}
            frameBorder='0'
            allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
          ></iframe>
        </Col>
        <Col className='info-col' xs='12' lg='5'>
          <h4>{props.videoTitle}</h4>
          <p>{props.description}</p>
        </Col>
      </React.Fragment>
    );
  };

  const renderPhoto = () => {
    return (
      <Col xs='12'>
        <img src={props.photo} alt={props.seoAlt} />
      </Col>
    );
  };

  return (
    <Container
      onClick={e =>
        e.target === e.currentTarget ? props.setPopupOn(false) : ''
      }
      className={`projects-video ${props.popupOn ? 'showPopup' : ''}`}
    >
      <Row className={`video-popup-row ${!props.video ? 'gallery' : ''}`}>
        <FontAwesomeIcon
          icon={faTimes}
          onClick={() => props.setPopupOn(false)}
        />
        {props.video ? renderVideo() : renderPhoto()}
      </Row>
    </Container>
  );
}

export default ProjectsVideo;
